/**
 * Ensures the value is a valid GUID
 * @param value string value
 */
export function isValidGUID(value: string): boolean {
    if (value.length > 0) {
        const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
        return regexExp.test(value);
    }

    return false;
}